module.exports = __webpack_public_path__ + "2967b177fc4f59adc7e15bb24a9f9933.jpg";